"use client";
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import "../../../building-blocks/inputs/internal/TextBelowInput.js";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import "../../../foundation/iconography/Icon.js";
import { Heading3Text } from "../../../foundation/typography/index.js";
import "react";
import "classnames";
import "../../../foundation/logos/Logo.css.js";
import { atoms } from "@gnist/themes/atoms.css.js";
import { TextSkeleton } from "../../../building-blocks/skeletons/TextSkeleton.js";
import "@gnist/themes/tokens.css.js";
import "react-content-loader";
const LoadingSkeleton = () => jsx(Fragment, { children: jsxs("div", { className: atoms({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start"
}), children: [jsx(Heading3Text, { children: jsx(TextSkeleton, { width: "10em" }) }), jsx("div", { className: atoms({ marginTop: "base" }), children: jsx(TextSkeleton, { width: "100px" }) })] }) });
export {
  LoadingSkeleton
};
